var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/promocode_logo.87c5e0f4.png","uri@2x": __webpack_public_path__ + "static/media/promocode_logo.7e5373be.png","uri@3x": __webpack_public_path__ + "static/media/promocode_logo.644381b6.png",
    width: 24,
    height: 24
});